import {ProviderType} from "../../app/interfaces/provider-type";

export const providerTypes: ProviderType[] = [
  {id: 1, name: "Unternehmen"},
  {id: 2, name: "BO-Institution"},
  {id: 3, name: "Schule"}
];
